import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Loading from "../Modals/Loading";
import { useNavigate } from "react-router-dom";
import quotationService from "../Services/quotationService";
import { LuEye } from "react-icons/lu";
import Head from "../Components/Head";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "react-icons/md";

const Quotation = () => {
  const [quotation, setQuotation] = useState([]);
  const [loading, setLoading] = useState(false);
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);
        const response = await quotationService.fetchAll();
        setQuotation(response.quotations);
        setLoading(false);
      } catch {}
    };
    getOrders();
  }, []);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white">
      <div className="fixed bottom-10 right-10 flex flex-col gap-3 z-50">
        <button
          onClick={() => topRef.current?.scrollIntoView({ behavior: "smooth" })}
          className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:-translate-y-1 transition-all duration-300 group"
          title="Scroll to Top"
        >
          <MdKeyboardDoubleArrowUp className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
        </button>
        <button
          onClick={() =>
            bottomRef.current?.scrollIntoView({ behavior: "smooth" })
          }
          className="w-11 h-11 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg hover:shadow-xl hover:bg-gray-50 hover:translate-y-1 transition-all duration-300 group"
          title="Scroll to Bottom"
        >
          <MdKeyboardDoubleArrowDown className="text-xl text-gray-600 group-hover:text-gray-900 transition-colors duration-300" />
        </button>
      </div>
      <div ref={topRef} />
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div>
          <div className=" flex flex-col">
            <Head
              heading={"Quotation"}
              button_text={"Add Quotation"}
              navigation={() => navigate("/quotation/add")}
            />
            <div className="table-div">
              <table>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px] font-bold">
                    <th className=" w-[1%] py-4 rounded-tl-lg pl-4">No.</th>
                    <th className="w-[3%] py-4">Date</th>
                    <th className="w-[6%] py-4">Customer</th>
                    <th className="w-[2%] py-4">Total Qty</th>
                    <th className="w-[2%] py-4">Ref No.</th>
                    <th className="w-[2%] py-4">Amount</th>
                    <th className="w-[2%] py-4">Amount Incl VAT</th>
                    <th className="w-[2%] py-4">Creation Date</th>
                    <th className="w-[1%] py-4">Status</th>
                    <th className="w-[1%] py-4 rounded-tr-lg text-center">
                      View
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {quotation?.map((value, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-100 text-left"
                    >
                      <td className="py-4 w-[1%] text-blue-500 font-bold pl-4">
                        {value.id}.
                      </td>
                      <td className="py-4 w-[3%]">
                        {moment(value.quotation_date).format("ll")}
                      </td>
                      <td className="py-4 w-[6%] pr-10 font-semibold">
                        {value.company_name}
                      </td>
                      <td className="py-4 w-[2%]">{value.total_quantity}</td>
                      <td
                        className={`py-4 w-[2%] font-semibold ${
                          value.status === "rejected"
                            ? "text-red-500"
                            : value.status === "pending"
                              ? "text-yellow-400"
                              : "text-green-600"
                        }`}
                      >
                        {value.reference_no}
                      </td>
                      <td className="py-4 w-[2%] font-medium">
                        {value.amount}
                      </td>
                      <td className="py-4 w-[2%]">{value.vat_amount}</td>
                      <td className="py-4 w-[3%]">
                        {moment(value.created_at).format("ll")}
                      </td>
                      <td className="py-4 w-[1%]">
                        <div className="flex justify-start">
                          <h1
                            className={`py-1 px-2 rounded-md uppercase font-semibold ${
                              value.status === "accepted"
                                ? "bg-green-500 bg-opacity-20 text-green-500"
                                : "bg-red-500 bg-opacity-20 text-red-500"
                            }`}
                          >
                            {value.status}
                          </h1>
                        </div>
                      </td>
                      <td className="py-4 w-[1%] text-center">
                        <button
                          className="rounded-md text-primary"
                          onClick={() =>
                            navigate(`/quotation/view?id=${value.id}`)
                          }
                        >
                          <LuEye className="h-4 w-4 text-sky-600" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
};

export default Quotation;
